import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "login-page" }
const _hoisted_2 = { class: "login-container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "input_container" }

import {ref} from "vue";
import EmailPassword from "supertokens-web-js/recipe/emailpassword";
import {showErrorAlert, showSuccessAlert} from "@/helpers/SweetAlertHelper";
import SimpleLayout from "@/layouts/simple/SimpleLayout.vue";
import logoImage from "@/assets/images/BeePallet_Logo_Black.png";
import {useRouter} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'ForgotPasswordPage',
  setup(__props) {

const email = ref("");
const isSubmitting = ref(false);
const router = useRouter();
const handleForgotPassword = async () => {
  if (!email.value) {
    showErrorAlert("Por favor, ingresa tu correo electrónico.");
    return;
  }

  isSubmitting.value = true;

  try {
    await EmailPassword.sendPasswordResetEmail({formFields: [{id: "email", value: email.value}]});
    showSuccessAlert("", "Si este correo existe, recibirás un enlace para restablecer tu contraseña.");
  } catch (error) {
    showErrorAlert("Error al enviar el correo de recuperación.");
  } finally {
    isSubmitting.value = false;
    router.push({name: "login"});
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(SimpleLayout, null, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, { to: "home" }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _unref(logoImage),
                class: "beepallet-logo",
                alt: "Logo de BeePallet"
              }, null, 8, _hoisted_3)
            ]),
            _: 1
          }),
          _createElementVNode("form", {
            class: "login-form",
            onSubmit: _withModifiers(handleForgotPassword, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_4, [
              _cache[1] || (_cache[1] = _createElementVNode("label", {
                class: "input_label",
                for: "username"
              }, "Ingresa tu correo electrónico para recibir un enlace de recuperación.", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "input-field is-placeholder",
                id: "email",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, email.value]
              ])
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("button", {
              type: "submit",
              class: "btn-primary-green"
            }, "Enviar enlace de recuperación", -1))
          ], 32)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})